import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputEntityKey } from './InputEntityKey.entity';
import { ReportOptionsValue } from './ReportOptionsValue.entity';

export class ExecuteReport2Request<T extends EMode = EMode.entity> {
  /** Alias: reportId */
  reportId?: any;
  /** Alias: entityKey */
  entityKey?: InputEntityKey<T>;
  /** Alias: options */
  options?: ReportOptionsValue<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<ExecuteReport2Request> = {
  reportId: {
    alias: 'reportId',
  },
  entityKey: {
    alias: 'entityKey',
  },
  options: {
    alias: 'options',
  },
  __typename: {
    alias: '__typename',
  },
};

export const executeReport2RequestEntityDefinition: EntitiyDefinition<ExecuteReport2Request> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'ExecuteReport2Request',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
